
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.7 10.7C15.1 9.6 16 7.9 16 6c0-3.3-2.7-6-6-6S4 2.7 4 6c0 1.9.9 3.6 2.3 4.7C2.6 12.2 0 15.8 0 20h2c0-4.4 3.6-8 8-8s8 3.6 8 8h2c0-4.2-2.6-7.8-6.3-9.3zM6 6c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4z"}})])
          )
        }
      }
    